import { render, staticRenderFns } from "./cashflowtrx.vue?vue&type=template&id=a96c2852&scoped=true"
import script from "./cashflowtrx.vue?vue&type=script&lang=js"
export * from "./cashflowtrx.vue?vue&type=script&lang=js"
import style0 from "./cashflowtrx.vue?vue&type=style&index=0&id=a96c2852&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96c2852",
  null
  
)

export default component.exports